module.exports = "<div class=\"visible-xs-block\" appResponsiveBreakpoint screen=\"xs\"></div>\n<div class=\"visible-sm-block\" appResponsiveBreakpoint screen=\"sm\"></div>\n<div class=\"visible-xs-or-sm-block\" appResponsiveBreakpoint screen=\"xs-or-sm\"></div>\n<div class=\"visible-md-block\" appResponsiveBreakpoint screen=\"md\"></div>\n<div class=\"visible-lg-block\" appResponsiveBreakpoint screen=\"lg\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/core/responsive-breakpoints/responsive-breakpoints.component.html
// module id = ./src/app/system/core/responsive-breakpoints/responsive-breakpoints.component.html
// module chunks = main